var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PoseTransition',[_c('Container',{staticClass:"introduction-ilustra"},[(_vm.img)?_c('img',{staticClass:"introduction-ilustra__image",attrs:{"src":_vm.imgUrl}}):_vm._e(),_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }